import { threePolicies } from '@/mocks/philosophyData';
import { useTranslation } from 'react-i18next';

export default function ThreePolicies() {
  const { t } = useTranslation();
  const policyKeys = [
    { title: 'philosophy.policies.1.title', desc: 'philosophy.policies.1.desc', icon: threePolicies[0].icon },
    { title: 'philosophy.policies.2.title', desc: 'philosophy.policies.2.desc', icon: threePolicies[1].icon },
    { title: 'philosophy.policies.3.title', desc: 'philosophy.policies.3.desc', icon: threePolicies[2].icon },
  ];

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            OUR APPROACH
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('philosophy.policies.title')}
          </h2>
          {String(t('philosophy.policies.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('philosophy.policies.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {policyKeys.map((policy, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-100/60 border border-background-200/60 p-6 md:p-8 flex flex-col items-start cursor-default"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-5">
                <i className={`${policy.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                {t(policy.title)}
              </h3>
              {String(t(policy.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
